import consumer from "./consumer"

let element = document.getElementById('assessment_id');
let assessmentId = element ? element.dataset.assessmentId : null;

if (assessmentId) {
  consumer.subscriptions.create({ channel: "AssessmentsChannel", id: assessmentId.toString() }, {
    connected() {
      // Called when the subscription is ready for use on the server
    },
  
    disconnected() {
      // Called when the subscription has been terminated by the server
    },
  
    received(data) {
      //show the weights div
      let weightsDiv = document.getElementById('weights');
      if (weightsDiv) {
        weightsDiv.style.display = 'block';
      }

      // --- Updated Weight Ranges Logic ---
      let weightRanges = data.weight_ranges || {}; // Use empty object if null/undefined
      const headcountInputs = document.querySelectorAll('input[type="number"][name*="[headcount]"]');

      // Reset all headcount fields first
      headcountInputs.forEach(input => {
        input.value = 0; // Reset to 0
        input.removeAttribute("readonly"); // Ensure it's not readonly before update
        input.dispatchEvent(new InputEvent('input'));
      });

      // Update fields based on received data
      for (const weightRangeId in weightRanges) {
        if (weightRanges.hasOwnProperty(weightRangeId)) {
          const headcount = weightRanges[weightRangeId];

          // 1. Find the hidden input field by its value (DB PK)
          const hiddenInputSelector = `input[type="hidden"][name*="[weight_ranges_attributes]"][name$="[id]"][value="${weightRangeId}"]`;
          const hiddenInput = document.querySelector(hiddenInputSelector);

          if (hiddenInput) {
             // 2. Get the hidden input's ID
             const hiddenInputId = hiddenInput.id; // e.g., "assessment_weight_ranges_attributes_4_id"

             // 3. Extract the index from the hidden input's ID using Regex
             const idRegex = /_(\d+)_id$/;
             const match = hiddenInputId.match(idRegex);

             if (match && match[1]) {
               const index = match[1]; // e.g., "4"

               // 4. Construct the target headcount input ID
               const headcountInputId = `assessment_weight_ranges_attributes_${index}_headcount`;

               // 5. Find the headcount input by its specific ID
               const headcountInput = document.getElementById(headcountInputId);

               if (headcountInput) {
                 // 6. Update the headcount input
                 headcountInput.value = headcount; // Assign the new value
                 headcountInput.dispatchEvent(new InputEvent('input')); // Trigger Stimulus/other listeners
                 headcountInput.setAttribute("readonly", "readonly"); // Make the field read-only
               }
             }
          }
        }
      }
      // --- End Updated Weight Ranges Logic ---

      //set the values of the avg_wt field
      let estWtElement = document.getElementById('assessment_avg_wt');
      if (estWtElement) {
        estWtElement.setAttribute('readonly', 'readonly');
        estWtElement.value = data.avg_wt;
        estWtElement.dispatchEvent(new InputEvent('input'));
      }

      //set the values of the head_weighed field
      let headWeighedElement = document.getElementById('head_weighed');
      if (headWeighedElement) {
        headWeighedElement.setAttribute('readonly', 'readonly');
        headWeighedElement.value = data.head_imported;
        headWeighedElement.dispatchEvent(new InputEvent('input'));
      }

      let heaviestWeight = document.getElementById('assessment_heaviest_wt');
       if (heaviestWeight) {
        heaviestWeight.setAttribute('readonly', 'readonly');
        heaviestWeight.value = data.heaviest_animal;
       }

      let manualWeights = document.getElementById('assessment_manual_weighed');
      if (manualWeights) {
        manualWeights.classList.add('disabled');
        // Optionally disable the input itself if needed
        // const manualInput = manualWeights.querySelector('input');
        // if (manualInput) manualInput.disabled = true;
      }


      let lightestWeight = document.getElementById('assessment_lightest_wt');
      if (lightestWeight) {
        lightestWeight.value = data.lightest_animal;
        lightestWeight.setAttribute('readonly', 'readonly');
      }

      // Called when there's incoming data on the websocket for this channel
    }
  });
}

